<template>
  <order-list v-if="displayOrders"
              :account="selectedAccount"
              :username="username"
              @apierror="setApiError"
              @apierrortext="setApiErrorText"
              @close="displayOrders=false">
  </order-list>
  <product-list v-if="displayProducts"
                :dairy-id="selectedAccount.dairyId"
                :dairy-name="selectedAccount.dairyName"
                :customer-id="selectedAccount.customerId"
                :customer-name="selectedAccount.customerName"
                :price-deck="selectedAccount.priceDeck"
                @apierror="setApiError"
                @apierrortext="setApiErrorText"
                @close="displayProducts=false">
  </product-list>
  <maintain-users v-if="displayUsers"
                  :account="selectedAccount"
                  @apierror="setApiError"
                  @apierrortext="setApiErrorText"
                  @close="displayUsers=false">
  </maintain-users>
  <add-account v-if="displayAddAccount"
               :dairy="selectedDairy"
               :accountlist="dairyAccounts"
               @apierror="setApiError"
               @apierrortext="setApiErrorText"
               @accounts="addToDairy"
               @close="displayAddAccount=false">
  </add-account>
  <list-announcements v-if="displayAnnouncements"
                      :dairyid="selectedDairy.id"
                      :dairyname="selectedDairy.name"
                      @close="displayAnnouncements=false">
  </list-announcements>
  <div class="centered">
    <div style="padding-top:1%;padding-bottom:1%;">
      <div v-show="adminOf.length" class="table-container" style="width:60%;max-height:525px;">
        <div style="width:100%;background:lightgray;border-bottom:1px solid black;">
          <div style="height:55px;">
            <div class="role-text" style="float:left;padding-top:1%;">Administrator</div>
            <div style="float:right;padding-top:1%;">
              <a href="./assets/administrator/help/How to Create Email Rules.pdf" target="_blank">
                <label class="action-icon-style">
                  <font-awesome-icon icon="file-pdf" size="lg"/>
                  <span style="display: block;">rules</span>
                </label>
              </a>
            </div>
            <div style="float:right;padding-top:1%;">
              <a href="./assets/administrator/help/RCO Admin Guide.pdf" target="_blank">
                <label class="action-icon-style">
                  <font-awesome-icon icon="file-pdf" size="lg"/>
                  <span style="display: block;">guide</span>
                </label>
              </a>
            </div>
          </div>
        </div>
        <table>
          <template v-for="dairy in adminOf" :key="dairy.id">
            <tr>
              <td style="text-align:left;font-weight:bold;">
                <font-awesome-icon
                    v-on:click="showAccounts(dairy)"
                    :icon="(dairy.id === selectedDairy.id) ? 'circle-chevron-down' : 'circle-chevron-right'"
                    size="xl"
                    style="padding-right:2%;"/>
                <sup>[{{ dairy.id }}]</sup>&nbsp;{{ dairy.name }}
              </td>
              <td/>
            </tr>
            <tr v-if="dairyTableRow.includes(dairy)">
              <td>
                <div class="table-container" style="max-height:345px;">
                  <table>
                    <thead>
                    <tr>
                      <th colspan="2" style="text-align:left;">accounts</th>
                      <th colspan="2" style="text-align:right;">
                        <label class="action-icon-style"
                               v-on:click="listAnnouncements(dairy)">
                          <font-awesome-icon icon="bullhorn" size="xl"/>
                          <span style="display: block;">announce</span>
                        </label>
                        <label class="action-icon-style"
                               v-on:click="displayAddAccount = true">
                          <font-awesome-icon icon="store" size="xl"/>
                          <span style="display: block;">add</span>
                        </label>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="account in dairyAccounts" :key="account"
                        style="border:none;background:lemonchiffon;">
                      <td>
                        <div style="text-align:left;font-weight:bold;">
                          <sup>[{{ account.customerId }}]</sup> {{ account.customerName }}
                        </div>
                        <div class="product-banner">
                          {{ account.deliveryType }} | deck: {{ account.priceDeck }}
                        </div>
                      </td>
                      <td colspan="3" style="justify-content:space-evenly;">
                        <label class="action-icon-style" v-on:click="openProductList(account)">
                          <font-awesome-icon icon="cow" size="xl"/>
                          <span style="display: block;">products</span>
                        </label>
                        <label class="action-icon-style" v-on:click="openOrderList(account)">
                          <font-awesome-icon icon="basket-shopping" size="xl"/>
                          <span style="display: block;">orders</span>
                        </label>
                        <label class="action-icon-style" v-on:click="openUserList(account)">
                          <font-awesome-icon icon="users" size="xl"/>
                          <span style="display: block;">users</span>
                        </label>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import OrderList from '@/components/ordering/List'
import ProductList from '@/components/ordering/products/List'
import AddAccount from '@/components/administrator/account/AddAccount'
import MaintainUsers from '@/components/administrator/account/assignment/Maintain'
import ListAnnouncements from '@/components/administrator/dairy/announcement/ListAnnouncements.vue';

export default {
  name: 'AdminComponent',
  props: ['username'],
  emits: ['apierror', 'apierrortext'],
  components: {
    OrderList,
    ProductList,
    AddAccount,
    MaintainUsers,
    ListAnnouncements
  },
  data: function () {
    return {
      adminOf: [],
      dairyTableRow: [],
      dairyAccounts: [],
      selectedAccount: {},
      selectedDairy: {},
      selectedUser: '',
      displayOrders: false,
      displayProducts: false,
      displayAddAccount: false,
      displayUsers: false,
      apiError: false,
      apiErrorText: '',
      announcementList: [],
      displayAnnouncements: false,
    }
  },
  methods: {
    showAccounts(dairy) {
      this.dairyTableRow = []

      if (this.selectedDairy !== dairy) {
        this.axios
            .get('admin/dairyAccounts', {
              params: {
                dairyId: dairy.id
              }
            })
            .then(response => {
              this.dairyAccounts = _.orderBy(response.data, ['customerName', 'customerId'], ['asc', 'asc'])

              this.selectedDairy = {}
              this.selectedDairy = dairy
              this.dairyTableRow.push(dairy)
            })
            .catch(error => {
              this.setApiError(true)
              this.setApiErrorText(error.response.statusText)
            })
      } else {
        this.selectedDairy = {}
      }
    },
    addToDairy: function (accounts) {
      this.dairyAccounts = _.orderBy(accounts, ['customerName', 'customerId'], ['asc', 'asc'])
    },
    openProductList: function (account) {
      this.selectedAccount = account
      this.displayProducts = true
    },
    openOrderList: function (account) {
      this.selectedAccount = account
      this.displayOrders = true
    },
    openUserList(account) {
      this.selectedAccount = account
      this.displayUsers = true
    },
    listAnnouncements(dairy) {
      this.selectedDairy = dairy;
      this.displayAnnouncements = true
    },
    setApiError: function (isError) {
      this.$emit('apierror', isError)
    },
    setApiErrorText: function (text) {
      this.$emit('apierrortext', text)
    }
  },
  created() {
    this.axios
        .get('admin/adminOf')
        .then(response => {
          this.adminOf = _.orderBy(response.data, ['id'], ['asc'])
        })
        .catch(error => {
          this.setApiError(true)
          this.setApiErrorText(error.response.statusText)
        })
  },
}
</script>

<style scoped>
.action-icon-style {
  color: black;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}
</style>
